import { useQueryClient } from '@tanstack/react-query';

import { useDeleteWorkstream } from '@/api/rest/resources/workstreams';
import { assertIsDefined } from '@/utils/assert';

export const useDeleteWorkstreamAction = (organizationId: string) => {
  const deleteMutation = useDeleteWorkstream();
  const queryClient = useQueryClient();

  const submit = async (workstreamId: string, onSuccess?: () => void, onError?: (error: Error) => void) => {
    assertIsDefined(workstreamId, 'workstreamId');

    await deleteMutation.mutateAsync(
      {
        pathVariables: {
          organization_id: organizationId,
          id: workstreamId,
        },
        queryParams: undefined,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['organization', organizationId, 'workstreams'] });
          onSuccess?.();
        },
        onError: (error) => {
          onError?.(error as Error);
        },
      },
    );
  };

  const isDeleting = deleteMutation.isPending;

  return { submit, isDeleting };
};
